import { useBrowserEffect } from '@mnd-frontend/hooks';
import { select } from 'd3-selection';
import { memo, useRef, useState } from 'react';
import { SvgResponsive } from '../lib/components';
import { useEventContext } from '../lib/context';
import { useForce, usePackLayout } from '../lib/hooks/d3';
import { useIsHoveredDay } from '../lib/hooks/data';
import Bubble from './Bubble';

const BubbleChart = memo(({ data, dataKey, color, minWidth, height, utcOffset }: any) => {
  const { handleClick } = useEventContext();
  const isHoveredDay = useIsHoveredDay(data, utcOffset);

  const ref = useRef(null);
  const [width, setWidth] = useState<any>();

  const padding = 8;
  const nodes = usePackLayout(data, dataKey, width, height, padding);

  const simulation = useForce(nodes, width, height, padding);
  useBrowserEffect(() => {
    if (simulation) {
      const d3Selection = select(ref.current).selectAll('circle');
      simulation.on('tick', function (this: any) {
        const nodes = this.nodes();
        d3Selection
          .data(nodes)
          .attr('cx', (d: any) => d.x)
          .attr('cy', (d: any) => d.y);
      });
    }
  }, [simulation]);

  return (
    <SvgResponsive
      ref={ref}
      minWidth={minWidth}
      height={height}
      onChangeWidth={setWidth}
      onClick={handleClick}
    >
      {nodes.map((bubble: any) => (
        <Bubble
          key={bubble.data.id}
          id={bubble.data.id}
          x={bubble.x}
          y={bubble.y}
          r={bubble.r}
          color={color}
          isHoveredDay={isHoveredDay}
        />
      ))}
    </SvgResponsive>
  );
});

export default BubbleChart;
